<div class="miniBar">
  <div class="miniBarProgress1" [style.width.%]="[progressMiniBar1Width]">
    <span *ngIf="showValues">{{ value1 }}%</span>
  </div>
  <div class="miniBarProgress2" [style.width.%]="[progressMiniBar2Width]">
    <span *ngIf="showValues">{{ value2 }}%</span>
  </div>
</div>
<!--<app-progress-bar [value1]="progressBarValue1" [value2]="progressBarValue2"></app-progress-bar>-->
